import React from 'react';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';
import bgImage from '../Assets/Images/ServiceBg.jpeg';
import CircularText from '../Components/CircularText';
import ServiceImg1 from '../Assets/Images/ServiceImg1.jpeg';
import ServiceImg2 from '../Assets/Images/ServiceImg2.png';
import ServiceImg3 from '../Assets/Images/ServiceImg3.jpeg';
import ServiceImg4 from '../Assets/Images/ServiceImg4.png';
import ServiceImg5 from '../Assets/Images/ServiceImg5.jpg';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { FaArrowDown } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';



const techData = [
  {
    title: 'Frontend Developement',
    highlight: 'Frontend',
    items: [
      { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
      { name: 'Angular', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg' },
      { name: 'Next.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg' },
    ],
  },
  {
    title: 'Backend Developement',
    highlight: 'Backend',
    items: [
      { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
      { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
      { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
      { name: '.Net', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dot-net/dot-net-original.svg' },
    ],
  },
  {
    title: 'Data bases',
    highlight: 'Data',
    items: [
      { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
      { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
      { name: 'PostgreSQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
    ],
  },
  {
    title: 'Mobile Developement',
    highlight: 'Mobile',
    items: [
      { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
      { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
    ],
  },
  
  {
    title: 'Cloud Services',
    highlight: 'Cloud',
    items: [
      { name: 'AWS', icon: 'https://img.icons8.com/?size=100&id=33039&format=png&color=000000' },
      { name: 'Google Cloud', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg' },
      { name: 'Microsoft Azure', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg' },
    ],
  },
  {
    title: 'DevOps Tools',
    highlight: 'DevOps',
    items: [
      { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
      { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg' },
      { name: 'GitLab CI/CD', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg' },
    ],
  },
];



const Services = () => {
    const navigate = useNavigate();

    useEffect(() => {
  AOS.init({ duration: 1000, once: true });
}, []);

AOS.init({
  duration: 1000,
  offset: 120,
  once: true, // run only once
});


  const handleScroll = () => {
    const section = document.getElementById('scrollDown');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

const serviceData = [
  {
    title: 'Software Development',
    description: 'Custom software solutions tailored to meet your business needs — from enterprise platforms to cloud-native applications that drive performance and growth.',
    image: ServiceImg1,
  },
  {
    title: 'Digital Marketing',
    description: 'Maximize your digital reach with performance-driven strategies, SEO, content marketing, social media campaigns, and AI-powered analytics.',
    image: ServiceImg2,
  },
  {
    title: 'Web & Mobile Apps',
    description: 'We design and develop responsive, scalable, and intuitive web and mobile applications that deliver exceptional user experiences and business results.',
    image: ServiceImg3,
  },
  {
    title: 'Medical Coding',
    description: 'We provide specialized healthcare and medical coding services for all inpatient & outpatient healthcare requirements. We are one of the world\'s leading providers of medical billing and coding services. If you are looking for accurate healthcare coding services, we can deliver what you need.',
    image: ServiceImg5,
  },
];


  return (
    <>
      <div className="text-white">
     <Header />

{/* Hero Section */}
<div
  className="relative h-screen flex items-center justify-center text-white"
  style={{
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
  }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black opacity-65"></div>

  {/* Hero Content */}
  <div className="relative z-10 text-center px-4 md:px-0 flex flex-col items-center justify-center">
    <div className="text-xl md:text-2xl font-semibold">Services</div>


    <div className="w-24 h-1 bg-white my-2 mb-4"></div>
    <h1 className="text-4xl md:text-6xl font-bold mb-2">What WE DO</h1>


    <h2 className="text-2xl md:text-4xl font-normal mb-10">
      Turning uncertainty into opportunity
    </h2>

    {/* Scroll Down Circle */}
    <div className="relative w-28 h-28 flex items-center justify-center mt-10">
      <div onClick={handleScroll} className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
        <CircularText  text="VIVEKASOFTEK @ EXPLORE " spinDuration={20} />
      </div>
      <div className="z-10 flex items-center justify-center">
        <button onClick={handleScroll}>
          <FaArrowDown size={28} className="text-white" />
        </button>
      </div>
    </div>
  </div>
</div>


        {/* Second Section */}
        <div id="scrollDown" className="bg-white text-black px-6 md:px-16 py-20 text-left">
          <h2 className="text-2xl md:text-4xl font-bold mb-6">
            Your end-to-end application modernization partner
          </h2>
          <p className="text-md md:text-xl text-justify font-normal max-w-4xl">
            Businesses are struggling to manage the cost and complexity of legacy technology while operating
            effectively and preparing for the future. Our end-to-end work enhances operations, increases efficiency,
            removes technical debt and modernizes applications for what is coming next.
          </p>
        </div>


        {/* Third Section - 4 Services with alternating layout and animations */}
<div className="relative z-10 grid grid-cols-1 gap-20 p-[6%]">
{/* Background image */}
  <div
    className="absolute inset-0 bg-cover bg-center bg-fixed"
    style={{ backgroundImage: `url(${bgImage})` }}
  ></div>

  {/* Overlay to reduce brightness and improve readability */}
  <div className="absolute inset-0 bg-black bg-opacity-80"></div>
  {serviceData.map((service, index) => {
    const isEven = index % 2 === 0;

    // Determine AOS animation directions
    const imgAnim = isEven ? 'fade-up' : 'fade-up';
    const contentAnim = isEven ? 'fade-up' : 'fade-up';

    return (
      <div
        key={index}
        className={`flex flex-col md:flex-row items-center gap-8   ${
          !isEven ? 'md:flex-row-reverse' : ''
        }`}
      >
        <img
          data-aos={imgAnim}
          src={service.image}
          alt={service.title}
          className="w-full md:w-1/2 rounded-xl shadow-lg"
        />
        <div
          data-aos={contentAnim}
          className="md:w-1/2 text-center md:text-left space-y-4"
        >
          <h3 className="text-2xl md:text-3xl font-semibold">{service.title}</h3>
          <p className="text-base md:text-lg text-justify font-medium">{service.description}</p>
          <button
  onClick={() => navigate('/products')}
  className="group inline-flex items-center mt-4 text-white border border-white px-5 py-2 hover:bg-[#ffffff27] transition duration-300"
>
  Know More
  <FaArrowRight
    className="ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
  />
</button>

        </div>
      </div>
    );
  })}
</div>

{/* Technology Stack Section */}
<div className="bg-white text-black px-6 md:px-16 py-20" id="tech-stack">
  <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">Our Technology Stack</h2>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
    {techData.map((tech, idx) => (
      <div
        key={idx}
        className="bg-white shadow-lg rounded-xl p-6 hover:shadow-2xl transition duration-300"
        data-aos="fade-up"
        data-aos-delay={idx * 150} // delay increases for each card
        data-aos-duration="800"
      >
        <h3 className="text-lg font-semibold text-[#529ef5] mb-8">
          <span className="text-black underline decoration-[#529ef5] font-bold">
            {tech.highlight}
          </span>{' '}
          {tech.title.replace(tech.highlight, '')}
        </h3>
        <ul className="space-y-6">
          {tech.items.map((item, index) => (
            <li key={index} className="flex items-center gap-3">
              <img src={item.icon} alt={item.name} className="h-6 w-6" />
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
</div>







      </div>

      <Footer/>
    </>
  );
};

export default Services;
